import { useEffect, useState } from "react";
import { Link } from "react-router-dom";


function SideNav({ rightNav, outside, setRightNav, setFortuneList, menuList }) {


    return (
        <div className={rightNav ? 'sideNav_menu active' : 'sideNav_menu'} ref={outside} onClick={(e) => {
            if (e.target == outside.current) setRightNav(false);
        }}>
            <div className="sideNav_content">
                <div className="logoContent">
                    <Link to="/" className="logo">
                        <img src={process.env.PUBLIC_URL + '/image/p_logo.png'} alt='별별운세' />
                    </Link>
                    <button type="button" className="navClose" onClick={() => { setRightNav(!rightNav); }}>
                        <img src={process.env.PUBLIC_URL + '/image/close.png'} />
                    </button>
                </div>
                {
                    menuList.NAME 
                    ?
                    <div className="useProfile">
                        <div className="userImg">
                            <p className="icon">
                                <img src={process.env.PUBLIC_URL + `${decodeURIComponent(menuList.ZODIAC_ANIMAL)}`}/>
                            </p>
                            <img src={process.env.PUBLIC_URL + `${decodeURIComponent(menuList.SEX)}`}/>
                        </div>
                        <div className="userInfo">
                            <h5 className="userName">{menuList.NAME}</h5>
                            <span>{menuList.CONTENT}</span>
                        </div>
                        <div className="userFortune">
                            <FortuneResult menuList={menuList}></FortuneResult>
                        </div>
                    </div>
                    :
                    <div className="nullUserInfo">
                        <h4>운세를 보기 위해선 기본 정보가 필요해요 !</h4>
                    </div>
                }
                {/* <Link to="/info?return_url='/'" className="infoChange">{menuList.MENU_BTN}</Link> */}
                <Link to="/FortuneInfo" className="infoChange">{menuList.MENU_BTN}</Link>

                <div className="footerInfo">
                    <ul className="footerList">
                        <li>
                            <span>주식회사 인피니티커넥트</span> 대표 이호원
                        </li>
                        <li>
                            <span>사업자등록번호</span> 456-86-02812
                        </li>
                        <li>
                            <span>주소</span> 경기도 부천시 원미구 중동로254번길로 90, 6층 6100호
                        </li>
                    </ul>
                    <Link to="/AgreePrivacy">개인정보처리방침</Link>
                    <span className="copyright">
                        Copyright © 2025 Infinity Connect - All right reserved
                    </span>
                </div>
            </div>
        </div>
    );
}

function FortuneResult({ menuList }) {
    return (
        <div dangerouslySetInnerHTML={{ __html: menuList.TODAY_SCORE }} />
    );
}

export default SideNav;